<script>
	import Multiselect from "vue-multiselect";
	import AddNewPaymentMethodForm from '../../components/widgets/AddNewPaymentMethodForm';
	import SideSlidePanel from "../../components/widgets/SideSlidePanel"
	export default{
		components: { Multiselect, AddNewPaymentMethodForm, SideSlidePanel },
		data(){
			return{
				id: '',
				options: [
					{id: 1, name: 'text'},
					{id: 2, name: 'text2'}
				],
				search: '',
				currentPage: 1,
				order: 'desc',
      			sortby: 'id',
      			noresults: false,
      			limit: 0,
				limits: [
		        {value: 25, text: "25"},
		        {value: 50, text: "50"},
		        {value: 100, text: "100"},
		    	],
				response_error: [],
				addNewPanel: false,
			}
		},
		props: {
			isDisabled: {
				type: Boolean,
				default: () => false,
				}
		},
		created(){
			axios.get('/api/company/order/payment-options?page='+this.currentPage+'&limit='+this.limit+'&sortby='+this.sortby+'&order='+this.order+'&search='+this.search+'', {headers: {
                  'Authorization': 'Bearer ' + this.$attrs.api_token
              }}).then(response => {
				this.options = response.data.data;
				if(response.data.data.length == 0){
					this.noresults = true;
				}
			}).catch(error => {
				this.response_error = error.data;
			});
			this.id = this.$attrs.id;
			
		},
		methods:{
			updateDepartment: function(selectedOption){
				this.$emit('payment-method-selected', selectedOption);
			},
			customLabel ({ title, desc }) {
		      return `${title} – ${desc}`
		    }
		}
	}
</script>
<template>
	<div>

		<div  class="d-flex">
	<multiselect v-model="id" track-by="name" label="name" :options="options" @select="updateDepartment" :option-height="104" :disabled="isDisabled" class="flex-grow-5">
                     <!--<template slot="singleLabel" slot-scope="{ option }">{{ option.name }} - {{ option.jobtitle }}</template>-->
                     <template slot="singleLabel" slot-scope="{ option }"><div class="d-flex w-100 h-100"><div class="avatar-xs mr-4 my-auto">
                        <span class="avatar-title rounded-circle"><i :class="option.icon"></i></span>
                      </div>
      <div class="option__desc d-flex flex-row w-75"><span class="option__title ml-2 my-auto w-100">{{ option.name }}</span>
      </div>
  		</div></template>
    <template slot="option" slot-scope="{ option }">
    	<div class="d-flex"><div class="avatar-xs mr-4">
                        <span class="avatar-title rounded-circle"><i :class="option.icon"></i></span>
                      </div>
      <div class="option__desc d-flex flex-row w-50"><span class="option__title ml-2 my-auto w-100">{{ option.name }}</span>
      </div>
  		</div>
    </template>
                  </multiselect>

                  <a variant="light" class="my-auto btn btn-outline-light ml-2 flex-grow-1 h-100"  @click="addNewPanel = !addNewPanel" ><i class="mdi mdi-plus"></i></a>
               </div>



                  <SideSlidePanel :editPanel="addNewPanel" :panelClass="'edit-micropanel'" @close-panel="addNewPanel = !addNewPanel">
                  	<b-row class="px-4">
                  		<b-col>
                  			<h4>Add New Payment Method</h4>
                    		<AddNewPaymentMethodForm></AddNewPaymentMethodForm>
                    	</b-col>
                  	</b-row>
                  </SideSlidePanel>
   </div>
</template>
